import { z } from 'zod/v4';

export const configurationProfileSchema = z.object({
  name: z.string(),
  numberOfAssignedGroups: z.number(),
  id: z.number(),
  isVehicleGroupDefault: z.boolean(),
  availableUpdatesSyncInterval: z.number(),
  outOfRouteThreshold: z.number(),
  allowRoutingProfileEditing: z.boolean(),
  forceRoutingProfileSelection: z.boolean(),
  displayMapReporting: z.boolean(),
  allowAlternateRoutes: z.boolean().nullable(),
  overrideSettings: z
    .array(
      z.object({
        group: z.string(),
        key: z.string(),
        value: z.string(),
      })
    )
    .nullable()
    .optional(),
});

export type ConfigurationProfile = z.infer<typeof configurationProfileSchema>;
